export default __webpack_public_path__ + "static/media/condominios-de-lujo.a575cbf0.jpg";